module.exports = __webpack_public_path__ + "static/media/humidity.ec2d4e56.svg";